export interface ThemeStyle {
  [key: string]: string;
}

export const THEMES: { [key: string]: ThemeStyle } = {
  light: {
    '--tooltip-color-red': '#b91c1c',
    // Align with global palette (blue medium)
    '--main-color': '#01a8e8',
    '--grey-light-color': '#e0e7ff',
    '--text-color': '#1e293b',
    '--text-grey-color': '#64748b',
    '--text-hover-color': '#fff',
    '--ico-color': '#1e293b',
    '--theme-first-color': '#f1f5f9',
    '--theme-second-color': '#fff',
    '--theme-third-color': '#e2e8f0',
    '--bg-field-color': '#f8fafc',
    '--bg-cards-color': '#fff',
    '--border-color': '#e2e8f0',
    '--bg-hover-item': '#f1f5f9',
    '--bg-overlay': 'rgba(255, 255, 255, 0.85)',
    '--ico-hover-color': '#fff',
    '--bx-shadow-black': 'rgba(15, 23, 42, 0.08)',
    '--pkgBoldBlueOpacity': 'rgba(8, 60, 82, 0.10)',
    // Align with styles.scss token
    '--border-color-input': '#083c524d',
    '--theme-border-button-color': 'rgba(0, 0, 0, 0.08)',
    '--bg-opacity-color': 'rgba(0, 0, 0, 0.04)',
    '--admin-content-bg': '#f8fafc',
    '--admin-header-bg': '#fff',
    '--admin-sidebar-active': '#01a8e8'
  },
  // Thème océan (Dark - aligné pkg-web-app)
  ocean: {
    '--tooltip-color-red': '#ff6b9d',
    // Bleu medium comme couleur principale de l’app
    '--main-color': '#01a8e8',
    '--grey-light-color': '#1e2a3a',
    '--grey-light-color-opacity': 'rgba(30, 42, 58, 0.9)',
    '--text-color': '#e0f2fe',
    '--text-grey-color': '#94a3b8',
    '--text-hover-color': '#ffffff',
    '--ico-color': '#e0f2fe',
    '--theme-first-color': '#1e2a3a',
    '--theme-second-color': '#16202e',
    '--theme-third-color': '#0f1419',
    '--bg-cards-color': '#1e2a3a',
    '--bg-field-color': '#16202e',
    '--bg-hover-item': '#2a3441',
    '--bg-overlay': 'rgba(15, 20, 25, 0.9)',
    '--border-color': '#334155',
    '--ico-hover-color': '#ffffff',
    '--bx-shadow-black': '#0a0f14',
    '--pkgBoldBlueOpacity': 'rgba(1, 168, 232, 0.5)',
    '--border-color-input': '#334155',
    '--theme-border-button-color': 'rgba(224, 242, 254, 0.3)',
    '--bg-opacity-color': 'rgba(0, 0, 0, 0.07)',
    '--admin-content-bg': '#0b1220',
    '--admin-header-bg': '#16202e',
    '--admin-sidebar-active': '#01a8e8'
  },

  // Alias: "dark" utilise Ocean
  dark: {} as ThemeStyle,
};

THEMES['dark'] = THEMES['ocean'];

export type ThemeName = 'light' | 'dark' | 'ocean';

export function isDarkTheme(themeSlug: string): boolean {
  return themeSlug !== 'light';
}
